import { getToken, getUrlParam } from '@/libs/functions/getValue'
import goTo from '@/libs/functions/goTo'
import { getStorage } from '@/libs/functions/onStorage'
import { checkUserLogin } from '@/services'
import { useEffect } from 'react'

const DC_BACK_URL = 'dcBackUrl'

export default function BridgeAuth() {
  const redirectUrl = getUrlParam('redirectUrl') || ''
  const h5Token = getToken('dkToken') || getToken('h5Token') || ''
  const dcBackUrl = getStorage(DC_BACK_URL) || ''
  const tenantCode = getStorage('tenantCode') || ''

  useEffect(() => {
    ;(async () => {
      // await checkUserLogin()
      const decodeUrl = decodeURIComponent(redirectUrl)
      let targetUrl =
        decodeUrl.indexOf('?') > -1
          ? `${decodeUrl}&clientToken=${h5Token}&tenantCode=${tenantCode}`
          : `${decodeUrl}?clientToken=${h5Token}&tenantCode=${tenantCode}`

      targetUrl = `${targetUrl}${dcBackUrl ? `&cardUrl=${dcBackUrl}` : ''}`

      goTo(targetUrl, {
        type: 'replace',
      })
    })()
  }, [])
  return <></>
}
